import React from 'react';
import { ReactComponent as Success } from '../../../../assets/svg/success.svg'; // adjust path accordingly
/**
 * Component for Success Svg Icon
 * @returns 
 */
export const SuccessIconWithClass: React.FC = () => {
  return <Success className="fx-stepper-success-icon" />;
};